import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const MapsButton = ({ location }) => {
  return (
    <a
      href={location}
      target="_blank"
      rel="noopener noreferrer"
      className="icon-button"
    >
      <FontAwesomeIcon icon={faMapMarkerAlt} />
    </a>
  );
};

export default MapsButton;
